import { useEffect, useState, useContext, useRef } from "react";

import { AppContext } from '../../context.js';

function Drop(props) {
  const { children, className, close, side = 'left' } = props;

  const context = useContext(AppContext);

  const ref = useRef(null);
  const refd = useRef(null);
  
  const [expand, setExpand] = useState(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Close the dropdown when the close prop changes
  useEffect(() => {
    setExpand(false);
  }, [close]);

  // Set the position of the dropdown
  useEffect(() => {
    if (ref.current && ref.current.children[0]) {
      const childHeight = ref.current.children[0].offsetHeight;
      const childWidth = ref.current.children[0].offsetWidth;
      const rect = ref.current.children[0].getBoundingClientRect();

      setPosition({ 
        x: rect.left, 
        y: childHeight,
        width: childWidth
      });
    }
  }, [ref]);

  // Close the dropdown when the user clicks outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if ((ref.current && !ref.current.contains(event.target)) && (refd.current && !refd.current.contains(event.target))) {
        setExpand(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div 
      ref={ref} 
      style={{position: 'relative', display: 'inline-block', width: 'fit-content'}}
      onClick={(e) => setExpand(!expand)}
      className={className}
    >
      {children[0]}
      <div ref={refd}>
        {expand && (
          <div
            style={{
              position: 'absolute',
              display: expand ? 'block' : 'none',
              top: position.y,
              ...(side === 'center' ? {
                left: '50%',
                right: 'auto',
                transform: 'translateX(-50%)'
              } : side === 'right' ? {
                left: 'auto',
                right: 0
              } : {
                left: 0,
                right: 'auto'
              }),
              zIndex: 1000
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {children[1]}
          </div>
        )}
      </div>
    </div>
  );
}

export default Drop;